<input type="{{type}}" class="form-control" placeholder="{{placeholder}}" [formControl]="control"
    [min]="type === 'number' ? 0 : null" [attr.inputmode]="type === 'number' || type === 'tel' ? 'numeric' : null"
    [attr.pattern]="type === 'tel' ? '^[0-9+]*$' : null"
    [ngClass]="{ 'is-invalid': control.invalid && (control.touched || submitted) }"
    (blur)="onBlur()" (keydown)="onKeyDown($event)" (input)="onInput($event)" />
<div *ngIf="control.invalid && (control.touched || submitted)" class="invalid-feedback">
    <div *ngIf="control.errors?.['required']">{{errorMessage}}</div>
    <div *ngIf="control.errors?.['email']">Please enter a valid email address.</div>
    <div *ngIf="control.errors?.['pattern']">Only numbers and + are allowed.</div>
    <div *ngIf="control.errors?.['min']">{{placeholder}} value should be greater than 0</div>
</div>
